import { createFileRoute } from "@tanstack/react-router";
import { ResearchConsultingServicePage } from "./services_.research-consulting";

export const Route = createFileRoute("/services_/research-consulting-services")({
  head: () => ({
    meta: [
      {
        title: "Research & Consulting Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Data-Driven Research, Insights & Strategic Consulting.",
      },
    ],
  }),
  component: ResearchConsultingServicePage,
});
